import { render, staticRenderFns } from "./new_container.vue?vue&type=template&id=67001b70"
import script from "./new_container.vue?vue&type=script&lang=js"
export * from "./new_container.vue?vue&type=script&lang=js"
import style0 from "./new_container.vue?vue&type=style&index=0&id=67001b70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports